import React from "react";
import {
  appdownload,
  appstore,
  googleplay,
} from "../../../assets/img";
import { useSelector } from "react-redux";
import { shop_data } from "../edit/data";

const SectionFiveThemeOne = () => {
  const jsonData: any = useSelector<any>((state) => state?.shopHomeJsonList);
  // const jsonData = shop_data
  const settingsData: any = useSelector<any>((state) => state?.settings);
  // HTML
  return (
    <>
      <section className="sh1-mobapp-section">
        <div className="sh1-mobapp-subtract-top"></div>
        <div className="sh1-mobapp-subtract-body">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="sh1-mobapp-content text-center">
                  <h2 className="sh1-section-title" style={{
                      color: `#${jsonData?.theme_1?.home?.section_5?.h2color}`
                    }}>
                    {jsonData.theme_1?.home?.section_5?.title}
                  </h2>
                  <p style={{
                      color: `#${jsonData?.theme_1?.home?.section_5?.paracolor}`
                    }}>{jsonData.theme_1?.home?.section_5?.paragraph}</p>
                  <ul className="sh1-applinks">
                    <li>
                      <a
                        target="_blank"
                        href={
                          jsonData.theme_1?.home?.section_5?.mobile_link_section
                            ?.ios_link
                        }
                      >
                        <img src={appstore} alt="" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        href={
                          jsonData.theme_1?.home?.section_5?.mobile_link_section
                            ?.android_link
                        }
                      >
                        <img src={googleplay} alt="" />
                      </a>
                    </li>
                  </ul>

                  <ul className="sh1-appdata">
                  {jsonData.theme_1?.home?.section_5?.check_list.map(
              (items: any) => {
                return (
                  <li>
                    <img src={items.icons} alt="" />
                    <h4 style={{
                      color: `#${jsonData?.theme_1?.home?.section_5?.h3color}`
                    }}>{items.count}</h4>
                      <p style={{
                      color: `#${jsonData?.theme_1?.home?.section_5?.paracolor}`
                    }}>{items.title}</p>
                  </li>
                  );
                }
              )}

                  </ul>
                  {settingsData?.WebsiteSettings?.site_title_en.includes("Sasian") && (
                  <div className="sascallbtn py-5 text-center">
                    <a href="tel:+(44)7749300244" className="btn secondary-btn">Call Us</a>
                  </div>
                )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="sh1-mobapp-img text-center">
                  <img src={jsonData?.theme_1?.home?.section_5?.banner} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sh1-mobapp-subtract-bottom"></div>
      </section>
    </>
  );
};

export default SectionFiveThemeOne;
